import { Typography } from '@mui/material'
import { useTexts } from './useTexts'

export function Body() {
  const texts = useTexts()

  return <Typography>{texts.body}</Typography>
}
